import { Controller } from "@hotwired/stimulus";
import SignaturePad from "signature_pad";

// Connects to data-controller="contract"
export default class extends Controller {
  static targets = ["canvas", "file"];

  connect() {
    this.submitted = false;
    this.signaturePad = new SignaturePad(this.canvasTarget);
    this.resize();
  }

  resize() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    this.canvasTarget.width = this.canvasTarget.offsetWidth * ratio;
    this.canvasTarget.height = this.canvasTarget.offsetHeight * ratio;
    this.canvasTarget.getContext("2d").scale(ratio, ratio);
    this.signaturePad.clear();
  }

  clear() {
    this.signaturePad.clear();
  }

  save(event) {
    if (this.submitted) return;

    if (this.signaturePad.isEmpty()) {
      event.preventDefault();
      alert("Signature required.");
      return;
    }

    event.preventDefault();
    this.submitted = true;

    this.canvasTarget.toBlob((blob) => {
      const file = new File([blob], "signature.png", { type: "image/png" });

      const dt = new DataTransfer();
      dt.items.add(file);
      this.fileTarget.files = dt.files;

      this.element.requestSubmit();
    }, "image/png");
  }
}
